import React from 'react'

import {handleChange} from 'Skelet/src/modules/functions.js'
import ModalWrapper from 'Skelet/src/components/Modal_Wrapper.js'


class ModalSearchPolls extends React.Component {

  constructor(props) {
    super(props);
    this.state = {search:""};
  }

  render() {
    if(this.props.shouldShow) {

      return (
        <ModalWrapper switchState={this.props.close} mainClass="create-poll">
          <form onSubmit={(e) => {e.preventDefault();this.submitForm()}}>
            <div><input type="text" value={this.state.search} onChange={(e) => handleChange(this, "search", e)} maxLength="120" placeholder={this.props.i18n_texts["gen_search"][this.props.app_language]} autoFocus /></div>
            <div><input type="submit" value={this.props.i18n_texts["gen_search"][this.props.app_language]} /></div>
          </form>
        </ModalWrapper>
      );
    } else {
      return null;
    }
  }

  submitForm() {
    const {search} = this.state;
    let Csearch = search.replace(/'/g, "''");
    this.props.setParentSearch(Csearch);
    this.props.close();
  }

}

export default ModalSearchPolls



// WEBPACK FOOTER //
// ./src/containers/ModalSearchPolls.js